/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { LocaleCodeNormalizerError } from "./locale-code-normalizer-error";
export class LocaleCodeNormalizer {
    normalize(localeCode) {
        if (!localeCode) {
            return localeCode;
        }
        const segments = localeCode
            .replaceAll('-', '_')
            .split('_')
            .filter(s => s);
        if (segments.length != 2) {
            throw new LocaleCodeNormalizerError('Wrong locale code format detected.');
        }
        return `${segments[0].toLowerCase()}_${segments[1].toUpperCase()}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxlLWNvZGUtbm9ybWFsaXplci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvbG9jYWxpemF0aW9uL25vcm1hbGl6ZXJzL2xvY2FsZS1jb2RlLW5vcm1hbGl6ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxPQUFPLEVBQUMseUJBQXlCLEVBQUMsTUFBTSxnQ0FBZ0MsQ0FBQztBQUV6RSxNQUFNLE9BQU8sb0JBQW9CO0lBQ3RCLFNBQVMsQ0FBQyxVQUFrQjtRQUMvQixJQUFJLENBQUMsVUFBVSxFQUFFO1lBQ2IsT0FBTyxVQUFVLENBQUM7U0FDckI7UUFDRCxNQUFNLFFBQVEsR0FBRyxVQUFVO2FBQ3RCLFVBQVUsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDO2FBQ3BCLEtBQUssQ0FBQyxHQUFHLENBQUM7YUFDVixNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNwQixJQUFJLFFBQVEsQ0FBQyxNQUFNLElBQUksQ0FBQyxFQUFFO1lBQ3RCLE1BQU0sSUFBSSx5QkFBeUIsQ0FBQyxvQ0FBb0MsQ0FBQyxDQUFDO1NBQzdFO1FBQ0QsT0FBTyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLEVBQUUsSUFBSSxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLEVBQUUsQ0FBQTtJQUN0RSxDQUFDO0NBQ0oifQ==